/**
 * Extracted from `components/assessment-structure/import-source-picker.tsx` so Fast Refresh can preserve that file's
 * component state. A component file that also exports plain values makes
 * React remount the whole tree on every edit; these values have no JSX in
 * them, so they belong beside the component rather than inside it.
 */

export function importKindFromName(name: string): string {
  const dot = name.lastIndexOf(".")
  return dot > 0 ? name.slice(dot + 1).toUpperCase() : "FILE"
}

export function formatImportBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  const kb = bytes / 1024
  if (kb < 1024) return `${Math.round(kb)} KB`
  return `${(kb / 1024).toFixed(1)} MB`
}

export const IMPORT_DATE_TIME = new Intl.DateTimeFormat(undefined, {
  dateStyle: "medium",
  timeStyle: "short",
})

export const IMPORT_DATE = new Intl.DateTimeFormat(undefined, { dateStyle: "medium" })

export const IMPORT_TIME = new Intl.DateTimeFormat(undefined, { timeStyle: "short" })

export function formatImportDateTime(at: number): string {
  return IMPORT_DATE_TIME.format(new Date(at))
}

export function formatImportDateParts(at: number): { date: string; time: string } {
  const when = new Date(at)
  return {
    date: IMPORT_DATE.format(when),
    time: IMPORT_TIME.format(when),
  }
}
